<template>
  <div>
    <RevDrawer
      name="modal.orders.tab.filters.mobile"
      :title="i18n(translations.title)"
    >
      <template #body>
        <form>
          <div class="flex flex-col space-y-4">
            <RevInputText
              id="order-id"
              v-model="filtersValues.orderId"
              :label="i18n(sharedTranslations.orderId)"
              type="number"
            />
            <RevInputDate
              id="start-date"
              v-model="filtersValues.startDate"
              :label="i18n(sharedTranslations.startDate)"
            />
            <RevInputDate
              id="end-date"
              v-model="filtersValues.endDate"
              :label="i18n(sharedTranslations.endDate)"
              :picked-date-attrs="{ 'data-allow-mismatch': 'text' }"
            />
            <RevInputText
              id="sku"
              v-model="filtersValues.sku"
              :label="i18n(sharedTranslations.sku)"
              type="text"
            />
            <RevInputSelect
              v-if="shouldShowMissingActionFilter"
              id="missing-action"
              v-model="filtersValues.missingAction"
              :label="i18n(sharedTranslations.missingAction)"
              :options="missingActionOptions"
            />
            <RevInputSelect
              v-if="shouldShowOrderStateFilter"
              id="state"
              v-model="filtersValues.state"
              :label="i18n(sharedTranslations.orderState)"
              :options="statesOptions"
            />
            <RevInputSelect
              v-if="shouldShowBackshipFilter"
              id="isBackship"
              v-model="filtersValues.isBackship"
              :label="i18n(sharedTranslations.backShip)"
              :options="backshipOptions"
            />
            <RevInputText
              id="customer-first-name"
              v-model="filtersValues.customerFirstName"
              :label="i18n(sharedTranslations.customerFirstName)"
              type="text"
            />
            <RevInputText
              id="customer-last-name"
              v-model="filtersValues.customerLastName"
              :label="i18n(sharedTranslations.customerLastName)"
              type="text"
            />
            <RevInputSelect
              id="market"
              v-model="filtersValues.market"
              :label="i18n(sharedTranslations.market)"
              :options="availableMarketsOptions"
            />
            <RevInputSelect
              id="carrierId"
              v-model="filtersValues.carrierId"
              :label="i18n(sharedTranslations.shippingProvider)"
              :options="shippingProvidersOptions"
            />
            <RevInputSelect
              id="order-date-type"
              v-model="filtersValues.dateType"
              :label="i18n(sharedTranslations.dateType)"
              :options="dateTypeOptions"
            />
            <RevInputText
              id="order-line-id"
              v-model="filtersValues.orderLineId"
              :label="i18n(sharedTranslations.orderLineId)"
              type="number"
            />
          </div>
        </form>
      </template>
      <template #footer="{ close }">
        <div class="flex">
          <RevButton
            class="mr-1"
            full-width="always"
            type="submit"
            variant="primary"
            @click="handleSubmit(close)"
          >
            {{ i18n(sharedTranslations.submit) }}
          </RevButton>

          <RevButton
            full-width="always"
            variant="secondary"
            @click="handleReset(close)"
          >
            {{ i18n(sharedTranslations.reset) }}
          </RevButton>
        </div>
      </template>
      <template #trigger="{ open }">
        <RevStickyBar>
          <div class="flex items-center justify-center">
            <RevButton
              :icon="IconEqualizer"
              size="small"
              variant="secondary"
              @click="open"
            >
              {{ i18n(sharedTranslations.filter) }}
            </RevButton>
          </div>
        </RevStickyBar>
      </template>
    </RevDrawer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevInputDate } from '@ds/components/InputDate'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevStickyBar } from '@ds/components/StickyBar'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import { useFiltersOptions } from '../../../../composables/useFiltersOptions'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

import translations from './FiltersMobile.translations'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  shouldShowMissingActionFilter: boolean
  shouldShowOrderStateFilter: boolean
  shouldShowBackshipFilter: boolean
}>()

const i18n = useI18n()

const {
  availableMarketsOptions,
  backshipOptions,
  dateTypeOptions,
  missingActionOptions,
  statesOptions,
  shippingProvidersOptions,
} = useFiltersOptions()

function handleSubmit(closeModal: () => void) {
  props.submitFilters()
  closeModal()
}

function handleReset(closeModal: () => void) {
  props.resetFilters()
  closeModal()
}
</script>
